module.exports = __webpack_public_path__ + "static/media/outdr_otto.63d881cd.png";